import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form, Input } from 'antd';
import ENUMS from '../../constants/enums';
import { DisableMask } from '../common/FlexStyle';
import { themeColors } from '../../constants/themes';
import { getRegexForUrlValidation } from '../../utils/Discover';

const FormItem = Form.Item;

const Container = styled('div')`
  background-color: #ffffff;
  padding: 20px 15px 15px 15px;
  height: 255px;
  width: 237px;
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
  border-radius: 10px;
  position: relative;
  box-shadow: 0px 1px 7px 0 #0069fa26;
`;

const Heading = styled('div')`
  margin-bottom: 10px;
  padding-bottom: 36px;
  border-bottom: 1px solid ${themeColors.beige};
  height: 54px;
  font-size: 18px;
  color: ${themeColors.darkBlue};
  text-align: center;
  font-family: Heebo-Medium;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
`;

const ActiveHeading = styled('div')`
  width: 100%;
  height: 4px;
  background-color: #233b69;
  border-radius: 4px 4px 0 0;
  position: absolute;
  top: 0;
  left: 0;
`;

@injectIntl
@Form.create()
class DiscoverByURL extends Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line no-useless-escape
    this.urlRegex = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
    this.singleItemRegex = /\/ip\/\.*/;
  }
  /**
   * submitting the url area
   */
  handleSubmit = e => {
    const { handleSubmit } = this.props;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { search } = values;
        handleSubmit(search);
      }
    });
  };

  render() {
    const {
      form,
      intl,
      onChangeUpdate,
      isDisabled,
      isDisabledByStep,
      updatedBy,
      discoverValueString,
      discoverSourceId,
      onEnter,
    } = this.props;
    const { getFieldDecorator } = form;
    // const URLValidator = new RegExp('/(B00[A-Z0-9]{7})/g');
    return (
      <Container isDisabled={isDisabled} isDisabledByStep={isDisabledByStep}>
        {!isDisabled && updatedBy === ENUMS.COMMON.URL && <ActiveHeading />}
        {isDisabledByStep && <DisableMask border={10} />}
        <Heading>
          <FormattedMessage id="discover.DiscoverByUrl" />
        </Heading>
        <Form onSubmit={this.handleSubmit}>
          <FormItem>
            {getFieldDecorator('search', {
              initialValue: updatedBy === ENUMS.COMMON.URL ? discoverValueString : '',
              rules: [
                { required: true, message: intl.formatMessage({ id: 'discover.URLRequired' }) },
                {
                  pattern: this.urlRegex,
                  message: intl.formatMessage({ id: 'discover.URLInvalid' }),
                },
                {
                  pattern: getRegexForUrlValidation(discoverSourceId, ENUMS.SOURCE_MARKETPLACE),
                  message: intl.formatMessage({ id: 'discover.URLInvalidForSingle' }),
                },
              ],
            })(
              <Input
                css={{
                  width: '100%',
                  height: '22px',
                  borderRadius: '10px',
                  border: `solid 1px ${themeColors.dirtyBlue}`,
                }}
                // prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                onPressEnter={onEnter}
                placeholder={intl.formatMessage({ id: 'common.url' })}
                onChange={e => onChangeUpdate(e, ENUMS.COMMON.URL, form)}
                disabled={isDisabledByStep}
              />,
            )}
          </FormItem>
        </Form>
      </Container>
    );
  }
}

DiscoverByURL.propTypes = {
  form: PropTypes.object,
  intl: PropTypes.object,
  handleSubmit: PropTypes.func,
  onChangeUpdate: PropTypes.func,
  onEnter: PropTypes.func,
  isDisabled: PropTypes.bool,
  isDisabledByStep: PropTypes.bool,
  updatedBy: PropTypes.number,
  discoverValueString: PropTypes.string,
  discoverSourceId: PropTypes.number,
};

export default DiscoverByURL;
